
import {
  MDBBtn,
} from 'mdb-react-ui-kit';

export default function Part1() {



  return (
    
      <div
        id='intro-example'
        className='text-center bg-image'
        style={{ backgroundImage: "url('/test2.png')", marginTop: '60px'
        }}
      >
        <div className='d-flex align-items-center'
            style={{ 
                textAlign: 'center', 
                position: "absolute",
                top: "60vh", /* 30% de la hauteur de l’écran */
                left: "50%",
                transform: "translateX(-50%)",
                flexDirection: 'column', 
                backgroundColor: "rgba(48, 62, 96, 0.6)",
                width: '100vw',
              }}>
          <p className="p-title" style={{
                  fontFamily: 'Consolas, monospace', /* Changer la police */
                  fontWeight: 'bold',
                  fontSize: "24px",
                  color: '#F2A541',
                  marginBottom: '0px'}}>
                Une Equipe - Deux Bateaux - Un Rêve
                </p>
          <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '20px', // Espacement entre le texte et les barres
                  width: '30%',
                  minWidth: '500px'
                }}>
              <span style={{
                flexGrow: 1,
                height: '2px',
                backgroundColor: '#F2A541',
                marginBottom: '0px'
              }}></span>
              <p className="p-subtitle" style={{
                  fontFamily: 'Consolas, monospace', /* Changer la police */
                  fontWeight: 'bold',
                  fontSize: '20px',
                  color: '#F2A541',
                  marginBottom: '0px'}}>
                  Suivre et rejoindre l'aventure
                  </p>
              <span style={{
                flexGrow: 1,
                height: '2px',
                backgroundColor: '#F2A541',
                marginBottom: '0px'
                }}></span>
              </div>
          <div className="d-flex gap-3">  
                        <MDBBtn
                          className="m-2 aabtn-title"
                          tag="a"
                          outline
                          size="lg"
                          rel="nofollow"
                          target="_blank"
                          href='https://drive.google.com/file/d/1Nphj4HcU6dg7MbsdRllbHPfX9FAp4rI_/view?usp=sharing'
                          style={{
                            width: '220px',
                            fontFamily: 'Consolas, monospace', /* Changer la police */
                            fontWeight: 'bold',
                            color: '#F2A541', /* Couleur du texte */
                            borderWidth: '4px', /* Épaisseur de la bordure */
                            borderColor: '#F2A541', /* Couleur de la bordure */
                            backgroundColor: 'rgba(48, 62, 96, 0.8)',
                            display: 'flex',         // Active flexbox
                            alignItems: 'center',    // Centre verticalement
                            justifyContent: 'center' // Centre horizontalement (facultatif)
                            }}
                        >
                          Newsletters
                        </MDBBtn>
                        <MDBBtn
                          className="m-2 aabtn-title"
                          tag="a"
                          outline
                          size="lg"
                          rel="nofollow"
                          target="_blank"
                          href='https://drive.google.com/file/d/1uNRK5KfadyKQdPu08-DnbNn4EfB21gyX/view?usp=sharing'
                          style={{
                            width: '220px',
                            fontFamily: 'Consolas, monospace', /* Changer la police */
                            fontWeight: 'bold',
                            color: '#F2A541', /* Couleur du texte */
                            borderWidth: '4px', /* Épaisseur de la bordure */
                            borderColor: '#F2A541', /* Couleur de la bordure */
                            backgroundColor: 'rgba(48, 62, 96, 0.8)',
                            display: 'flex',         // Active flexbox
                            alignItems: 'center',    // Centre verticalement
                            justifyContent: 'center'}}
                        >
                          Plaquette Sponsoring
                        </MDBBtn>
                      </div>

              
        </div>

      </div>
  );
}